import { Box, Flex, LayoutProps, useBreakpointValue } from '@chakra-ui/react'
import React, { FC } from 'react'
import { Card } from './Card'
import { ICommonProps } from './types'

export const CARD_SPACING = 4

const BANNER_WIDTH: LayoutProps['w'] = '100%'

type BannerProps = ICommonProps & {
  height?: LayoutProps['h']
  image: string
  itemsPerRow?: number
  width?: LayoutProps['w']
  openExperience: () => void
}

const Banner: FC<BannerProps> = ({
  actionCaption,
  actionIcon,
  actionText,
  showAction,
  actionDisabled,
  caption,
  handleAction,
  height,
  image,
  itemsPerRow = 3,
  openExperience,
  title,
  width = BANNER_WIDTH,
}) => {
  const defaultBannerHeight = useBreakpointValue({
    base: '13rem'
  })

  const defaultHeight = height ?? defaultBannerHeight

  // In order to calculate the width of the Card we need
  // Reference: https://chakra-ui.com/docs/styled-system/theme

  // Note: the height from the wrapper box is calculated in a way that takes
  // the defaultHeight value and adds the spacing to the bottom from the absolute
  // container of the Card component.
  return (
    <Box
      _hover={{ cursor: 'pointer' }}
      height={`calc(${defaultHeight} + 5rem)`}
      onClick={openExperience}
      width="full">
      <Flex
        alignItems="center"
        backgroundImage={image}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        borderRadius="3xl"
        boxShadow="md"
        direction="column"
        filter="drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1))"
        height={defaultHeight}
        position="relative"
        width={width}>
        <Box
          bottom={-CARD_SPACING * 2}
          left={CARD_SPACING}
          position="absolute"
          width="full">
          <Card
            actionCaption={actionCaption}
            actionDisabled={actionDisabled}
            actionIcon={actionIcon}
            actionText={actionText}
            bannerWidth={width}
            caption={caption}
            handleAction={handleAction}
            itemsPerRow={itemsPerRow}
            showAction={showAction}
            title={title}
          />
        </Box>
      </Flex>
    </Box>
  )
}

export { Banner }
